/*!
 * Copyright 2017 - 2020 by ChartIQ, Inc.
 * All rights reserved.
 */

import { forEach as asyncForEach } from "async";
import Logger from "../../../clients/logger";
import LauncherClient from "../../../clients/launcherClient";
import StorageClient from "../../../clients/storageClient";
import { BootTaskCallbackInterface } from "../types";

/**
 * Boot task that initializes any user-defined components using config settings
 * @private
 */
export class LoadUserDefinedComponentsTask {
	public start(doneCallback: BootTaskCallbackInterface) {
		Logger.system.debug("loadUserDefinedComponentsTask start");
		StorageClient.get({ topic: "finsemble", key: "userDefinedComponents" }, (err, response) => {
			const data = response || {};
			if (err) {
				Logger.system.debug("loadUserDefinedComponentsTask error", err);
				doneCallback("loadUserDefinedComponentsTask", "bootTasks", "failed");
			} else {
				const udComponents = Object.keys(data);
				asyncForEach(
					udComponents,
					(key, done) => {
						const component = data[key];
						LauncherClient.addUserDefinedComponent(
							{
								name: component.component.type,
								url: component.window.url,
							},
							done
						);
					},
					() => {
						doneCallback("loadUserDefinedComponentsTask", "bootTasks", "completed");
					}
				);
			}
		});
	}
}
